import { Navigate } from "react-router-dom";
import React from "react";
import PropTypes from "prop-types";

function ProtectedRoute({ children }) {
  const token = sessionStorage.getItem("access-token");
  const isVerified = sessionStorage.getItem("verify");
  if (!token && (!isVerified || isVerified === "no")) return <Navigate to="/login" replace />;
  return children;
}
ProtectedRoute.propTypes = {
  children: PropTypes.objectOf(PropTypes.any),
};
ProtectedRoute.defaultProps = {
  children: PropTypes.objectOf(PropTypes.any),
};
export default ProtectedRoute;
